// extracted by mini-css-extract-plugin
export default {"table":"UsersTable_table__0Vuq2","row":"UsersTable_row__Nby7Z","text":"UsersTable_text__z639N","actions":"UsersTable_actions__+wRhp"};